import React from "react";
import { BrowserRouter as Router, Route, Redirect } from "react-router-dom";
import HomePage from "pages/home/home";
import PartidosEnvivo from "components/partidos-envivo/partidos-envivo";


function App() {

    return (
        <>
            <Router>
            <Route path="/" exact>
                <Redirect to="/resultados" />
            </Route>

                <Route path="/resultados" exact component={HomePage}></Route>

            </Router>
        </>
    )
}

export default App;
